import { animate, stagger, inView } from 'motion';

document.addEventListener('DOMContentLoaded', () => {
	const titles = document.querySelectorAll(
		'.wp-block-improntad-theme-blocks-section-title'
	);

	titles.forEach((element) => {
		new SectionTitleBlock(element);
	});
});

class SectionTitleBlock {
	constructor(element) {
		this.element = element;
		this.enableAnimation =
			element.getAttribute('data-enable-animation') === 'true';

		if (this.enableAnimation) {
			this.init();
		}
	}

	init() {
		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		if (prefersReducedMotion) {
			return;
		}

		const titleElement = this.element.querySelector('.section-title');
		if (titleElement) {
			this.processTextElement(titleElement);
			this.animateTitle(titleElement);
		}

		const subtitleElement = this.element.querySelector('.section-subtitle');
		if (subtitleElement) {
			this.processTextElement(subtitleElement);
			this.animateTitle(subtitleElement);
		}
	}

	processTextElement(element) {
		const originalText = element.textContent.trim();
		console.log(
			'🚀 ~ SectionTitleBlock ~ processTextElement ~ originalText:',
			originalText
		);
		if (!originalText) {
			return;
		}

		element.setAttribute('aria-label', originalText);

		this.splitNodes(element);
	}

	splitNodes(parentNode) {
		const childNodes = Array.from(parentNode.childNodes);

		childNodes.forEach((node) => {
			if (node.nodeType === Node.TEXT_NODE) {
				const text = node.textContent;
				console.log(
					'🚀 ~ SectionTitleBlock ~ splitNodes ~ text:',
					text
				);
				const fragment = document.createDocumentFragment();
				const chars = text.split('');

				chars.forEach((char) => {
					const span = document.createElement('span');
					span.textContent = char;
					span.classList.add('char');
					span.setAttribute('aria-hidden', 'true');
					span.style.display = 'inline-block';
					span.style.opacity = '0';

					if (char === ' ') {
						span.innerHTML = '&nbsp;';
					}

					fragment.appendChild(span);
				});

				node.replaceWith(fragment);
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				this.splitNodes(node);
			}
		});
	}

	animateTitle(element) {
		inView(element, () => {
			animate(
				element.querySelectorAll('.char'),
				// { opacity: [0, 1], y: [20, 0] },
				{ opacity: [0, 1] },
				{ delay: stagger(0.02), duration: 0.5, easing: 'ease-out' }
			);
		});
	}
}
